module.exports = __webpack_public_path__ + "img/logo4.24425132.png";